<app-common-announcement [announcementMessage]="announcementData"></app-common-announcement>

<!-- @if(!this.schoolProps.properties.job_only_teacher){ -->
<nav class="navbar" id="consumer-header"
    *ngIf="!schoolProps.properties.job_only_teacher && schoolProps.properties.using_cc_to_B">
    <div class="container-fluid consumer-profile-header pl-20 pr-20 align-items-center">
        <div class="d-flex">
            <img alt="" appFocus appClick class="side_logo_text_booking d-show-350"
                src="assets/images/favicon/CCLogo.png" (click)="navigateToDashboard()" />
            <img alt="" appFocus appClick class="fav_logo d-none-350" src="assets/images/favicon/fav_icon_new.png" />
        </div>

        <!-- Hamburger menu button for offcanvas (visible on small screens) -->
        <button class="header-offcanvas-toggle" (click)="offcanvasOpen = true">
            <i class="bi bi-list"></i>
        </button>

        <div class="nav-item list-unstyled d-flex align-items-center">
            <li>
                <a class="nav-link" routerLink="teacher/dashboard" routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }">Home</a>
            </li>
            <li>
                <a class="nav-link" routerLink="/teacher/bookings" routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }">Booking requests</a>
            </li>
            <li>
                <a class="nav-link" routerLink="/teacher/calendar" routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }">Calendar</a>
            </li>
            <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle px-0" href="#" id="navbarDropdown" role="button"
                    data-bs-toggle="dropdown" aria-expanded="false" [ngClass]="{ 'active': activeSchoolDropdown }">
                    Schools <i class="bi bi-chevron-down"></i>
                </a>
                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                    <li>
                        <a class="dropdown-item" routerLink="/teacher/my-schools" routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }">My Schools</a>
                    </li>
                    <li>
                        <a class="dropdown-item" routerLink="/teacher/find-new-schools" routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }">Find New Schools</a>
                    </li>
                    <li>
                        <a class="dropdown-item" routerLink="/teacher/my-school-invites" routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }">School Invites</a>
                    </li>
                </ul>
            </li>
            <li>
                <a class="nav-link c-p" (click)="redirectToJobsUrl()" rel="noopener noreferrer">
                    Jobs
                </a>
            </li>
            <!-- <li>
                <a class="nav-link" routerLink="/teacher/learn" routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }">Learn</a>
            </li> -->
            <!-- @if(!this.schoolProps.properties.is_qld_teacher){ -->
            <li>
                <a class="nav-link" routerLink="/teacher/feedback" routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }">Vote for features</a>
            </li>
            <!-- } -->
            <button data-canny-changelog class="ml-20" aria-label="Changelog" title="Changelog">
                <img src="assets/images/MEgaphone.png" alt="Changelog" width="30" height="30" />
            </button>
            <span class="user-title bookings-tag ml-30" *ngIf="bookingsStatus">Bookings on</span>
            <span class="user-title bookings-tag-off ml-30" *ngIf="!bookingsStatus">Bookings off</span>

            <ng-container *ngIf="isAuthenticated;">
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle ml-10 px-0" href="#" id="navbarDropdown" role="button"
                        data-bs-toggle="dropdown" aria-expanded="false">
                        <img width="42px" alt="i" class="school_avatar  mr-3"
                            [src]="schoolLogo == '' || schoolLogo == null || schoolLogo == undefined ? 'assets/images/consumer/profile_monk.png' : schoolLogo" />
                        {{ teacherName && teacherName.trim() !== '' ? teacherName :
                        this.schoolProps.properties.full_name }} <i class="bi bi-chevron-down"></i>
                    </a>
                    <ul class="dropdown-menu profile-dropdownmenu" aria-labelledby="navbarDropdown">
                        <h2 class="user-title clr-white pl-8 fs-15 mt-10">Account</h2>
                        <li>
                            <a class="dropdown-item" routerLink="/teacher/profile" routerLinkActive="active"
                                [routerLinkActiveOptions]="{ exact: true }">My profile</a>
                        </li>
                        <li>
                            <a class="dropdown-item" routerLink="/teacher/settings" routerLinkActive="active"
                                [routerLinkActiveOptions]="{ exact: true }">Settings</a>
                        </li>
                        <h2 class="user-title clr-white pl-8 fs-15 mt-10">Manage</h2>
                        <li *ngIf="from_page_cookie == 'loginas'">
                            <a class="dropdown-item" (click)="backToAdmin()">Back to admin</a>
                        </li>
                        <li>
                            <a class="dropdown-item" role="button" (click)="logout()">Logout</a>
                        </li>
                    </ul>
                </li>
            </ng-container>

        </div>
    </div>
    <!-- Offcanvas sidebar for navigation (visible on small screens) -->
    <div class="offcanvas-header-nav" [ngClass]="{ 'open': offcanvasOpen }">
        <button class="close-btn" (click)="offcanvasOpen = false">
            <i class="bi bi-x-lg"></i>
        </button>
        <ul class="list-unstyled mt-40">
            <li><a class="nav-link" *ngIf="bookingsStatus" routerLink="teacher/dashboard" routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }" (click)="closeOffcanvasOnNav()">Home</a></li>
            <li><a class="nav-link" *ngIf="bookingsStatus" routerLink="/teacher/bookings" routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }" (click)="closeOffcanvasOnNav()">Booking requests</a>
            </li>
            <li><a class="nav-link" *ngIf="bookingsStatus" routerLink="/teacher/calendar" routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }" (click)="closeOffcanvasOnNav()">Calendar</a></li>
            <li><a class="nav-link c-p" (click)="redirectToJobsUrl()" routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }" (click)="closeOffcanvasOnNav()">Jobs</a></li>
            <li><a class="nav-link" routerLink="/teacher/profile" routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }" (click)="closeOffcanvasOnNav()">My profile</a></li>
            <li><a class="nav-link" routerLink="/teacher/settings" routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }" (click)="closeOffcanvasOnNav()">Settings</a></li>
            <li><a class="nav-link" role="button" (click)="logout(); closeOffcanvasOnNav()">Logout</a></li>
        </ul>
        <span class="user-title bookings-tag ml-30" *ngIf="bookingsStatus">Bookings on</span>
        <span class="user-title bookings-tag-off ml-30" *ngIf="!bookingsStatus">Bookings off</span>
    </div>
</nav>
<nav class="navbar" id="consumer-header"
    *ngIf="schoolProps.properties.job_only_teacher || !schoolProps.properties.using_cc_to_B">
    <div class="container-fluid consumer-profile-header pl-20 pr-20 align-items-center">
        <div class="d-flex">
            <img alt="" class="side_logo_text_booking d-show-350" src="assets/images/favicon/CCLogo.png"
                (click)="navigateToDashboard()" />
            <img alt="" class="fav_logo d-none-350" src="assets/images/favicon/fav_icon_new.png" />
        </div>

        <button class="header-offcanvas-toggle" (click)="offcanvasOpen = true">
            <i class="bi bi-list"></i>
        </button>

        <div class="nav-item list-unstyled d-flex align-items-center">
            <li>
                <a class="nav-link c-p" routerLink="/teacher/jobs" routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }">Jobs</a>
            </li>
            <li>
                <a class="nav-link" routerLink="/teacher/feedback" routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }">Vote for features</a>
            </li>
            <button data-canny-changelog class="ml-20" aria-label="Changelog" title="Changelog">
                <img src="assets/images/MEgaphone.png" alt="Changelog" width="30" height="30" />
            </button>
            <span class="user-title bookings-tag ml-30" *ngIf="bookingsStatus">Bookings on</span>
            <span class="user-title bookings-tag-off ml-30" *ngIf="!bookingsStatus">Bookings off</span>

            <ng-container *ngIf="isAuthenticated;">
                <li class=" nav-item dropdown">
                    <a class="nav-link dropdown-toggle ml-10 px-0" href="#" id="navbarDropdown" role="button"
                        data-bs-toggle="dropdown" aria-expanded="false">
                        <img width="42px" alt="i" class="school_avatar  mr-3"
                            [src]="
                schoolLogo == '' || schoolLogo == null || schoolLogo == undefined ? 'assets/images/consumer/profile_monk.png' : schoolLogo" />
                        {{this.schoolProps.properties.full_name || 'School'}} <i class="bi bi-chevron-down"></i>
                    </a>
                    <ul class="dropdown-menu profile-dropdownmenu" aria-labelledby="navbarDropdown">
                        <h2 class="user-title clr-white pl-8 fs-15 mt-10">Account</h2>
                        <li>
                            <a class="dropdown-item" routerLink="/teacher/profile" routerLinkActive="active"
                                [routerLinkActiveOptions]="{ exact: true }">My profile</a>
                        </li>
                        <li>
                            <a class="dropdown-item" routerLink="/teacher/settings" routerLinkActive="active"
                                [routerLinkActiveOptions]="{ exact: true }" (click)="closeOffcanvasOnNav()">Settings</a>
                        </li>
                        <li *ngIf="from_page_cookie == 'loginas'">
                            <a class="dropdown-item" (click)="backToAdmin()">Back to admin</a>
                        </li>
                        <li>
                            <a class="dropdown-item" role="button" (click)="logout()">Logout</a>
                        </li>
                    </ul>
                </li>
            </ng-container>
        </div>
    </div>
    <div class="offcanvas-header-nav" [ngClass]="{ 'open': offcanvasOpen }">
        <button class="close-btn" (click)="offcanvasOpen = false">
            <i class="bi bi-x-lg"></i>
        </button>
        <ul class="list-unstyled mt-40">
            <li><a class="nav-link" routerLink="/teacher/jobs" routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }" (click)="closeOffcanvasOnNav()">Jobs</a></li>
            <li><a class="nav-link" routerLink="/teacher/profile" routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }" (click)="closeOffcanvasOnNav()">My profile</a></li>
            <li><a class="nav-link" routerLink="/teacher/settings" routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }" (click)="closeOffcanvasOnNav()">Settings</a></li>
            <li><a class="nav-link" role="button" (click)="logout(); closeOffcanvasOnNav()">Logout</a></li>
        </ul>
        <span class="user-title bookings-tag ml-30" *ngIf="bookingsStatus">Bookings on</span>
        <span class="user-title bookings-tag-off ml-30" *ngIf="!bookingsStatus">Bookings off</span>
    </div>
</nav>